import { filterBy } from '@progress/kendo-data-query';
import { MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import React, { useEffect, useMemo, useState } from 'react'
import { UserApi } from '../../redux/api/UserApi';

export const TeamMultiSelect = (props: TeamListProps) => {
    const { data: teams, isFetching: teamsLoading } = UserApi.useGetTeamsQuery();
    const [teamsFiltered, setTeams] = useState([])
    const selectedTeams = useMemo(() => {
        return teams?.filter(t => props?.selectedTeamIds?.indexOf(t.ID) > -1);
    }, [teams, props?.selectedTeamIds]);

    useEffect(() => {
        console.log('Teams loading...', teams, selectedTeams)

        if (teams)
            setTeams(teams)
    }, [teams]);

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        setTeams(filterBy(teams?.slice(), event.filter));
    }
    if (!teamsFiltered)
        return <></>

    return (
        <>
            {/* selectedTeams:{JSON.stringify(selectedTeams)} / {teams.length} / {props.selectedTeamIds} */}
            <MultiSelect placeholder='Select multiple' filterable={true} popupSettings={{ className: 'z500' }} onFilterChange={onFilter} onChange={props.onChange} value={selectedTeams} data={teamsFiltered} dataItemKey="ID" textField="Dept_Name" loading={teamsLoading} />
        </>
    )
}

export type TeamListProps = {
    selectedTeamIds?: number[],
    onChange?: (e: MultiSelectChangeEvent) => void
}